import type { RouteObject } from "react-router-dom";
import AppError from "../app-error";
import InvoiceListPage, { invoiceListLoader } from "./List";
import InvoiceDetailPage, { invoiceDetailLoader } from "./Detail";
import InvoiceAuditPage, { invoiceAuditLoader } from "./Audit";
import CreditNotesPage, { creditNotesLoader } from "./CreditNotes";
import CreditNoteDetailPage, { creditNoteDetailLoader } from "./CreditNoteDetail";
import InvoiceSeriesPage, { invoiceSeriesLoader } from "./Series";
import NumberRouteError from "./number-route-error";

/**
 * Invoicing (core): list, detail, audit, credit notes, series. Registration and gst-summary are
 * a sibling fork's routes, added separately to avoid a duplicate-path collision.
 */
export const invoicingRoutes: RouteObject[] = [
  { path: "invoicing", element: <InvoiceListPage />, loader: invoiceListLoader, errorElement: <AppError /> },
  { path: "invoicing/credit-notes", element: <CreditNotesPage />, loader: creditNotesLoader, errorElement: <AppError /> },
  { path: "invoicing/credit-notes/:creditNoteNumber", element: <CreditNoteDetailPage />, loader: creditNoteDetailLoader, errorElement: <NumberRouteError /> },
  { path: "invoicing/series", element: <InvoiceSeriesPage />, loader: invoiceSeriesLoader, errorElement: <AppError /> },
  { path: "invoicing/:invoiceNumber", element: <InvoiceDetailPage />, loader: invoiceDetailLoader, errorElement: <NumberRouteError /> },
  { path: "invoicing/:invoiceNumber/audit", element: <InvoiceAuditPage />, loader: invoiceAuditLoader, errorElement: <NumberRouteError /> },
];
